import React, { useState, useEffect } from 'react'

export default function ToggleGroup({ options, active, onChange }) {
  return (
    <div style={{ display: 'flex', background: 'var(--bg-elevated)', borderRadius: 9, padding: 3, gap: 2, border: '1px solid var(--border)' }}>
      {options.map(opt => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          style={{
            padding: '5px 14px', borderRadius: 7, border: 'none', cursor: 'pointer',
            fontSize: 12, fontWeight: 600, transition: 'all 0.15s',
            background: active === opt.value ? 'var(--bg-surface)' : 'transparent',
            color: active === opt.value ? 'var(--text-primary)' : 'var(--text-muted)',
            boxShadow: active === opt.value ? 'var(--shadow-sm)' : 'none',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          {opt.dot && (
            <span style={{
              width: 7, height: 7, borderRadius: '50%',
              background: opt.dot, opacity: active === opt.value ? 1 : 0.4, flexShrink: 0
            }} />
          )}
          {opt.label}
        </button>
      ))}
    </div>
  )
}
